import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Button extends React.Component {

    render() {
        const {
            className,
            onClick,
            text,
            disabled,
        } = this.props;

        const btnClassName = classNames(
            'btn waves-effect waves-float',
            className,
            { 'disabled': disabled },
        );

        return (
            <button
                onClick={onClick}
                className={btnClassName}
                children={text}
                disabled={disabled}
            />
        );
    }

}

Button.propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

Button.defaultProps = {
    className: 'btn-default',
    onClick: () => {},
    disabled: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/Button.js